import { useState } from "react";

const DecimalInput = ({ id, text, value, onChange, className = "", placeholder = "" }) => {
  const [errorRegex, setErrorRegex] = useState(false);
  const handleChange = (e) => {
    onChange(e);
    const newVal = e.target.value;
    const regex = /^\d*(?:.\d*)?$/;

    if (regex.test(newVal)) {
      setErrorRegex(false);
    } else {
      setErrorRegex(true);
    }
  };

  return (
    <div>
      <label htmlFor={id} className="text-gray-800">{text}</label>
      {errorRegex ? <p className={"text-sm text-red-500"}>*El valor debe ser Decimal</p> : null}
      <input
        type="text"
        id={id}
        name={id}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className={`block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900  -outline-offset-1 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 ${className} `
          + (errorRegex
            ? "outline-red-500 outline-2"
            : "outline-gray-400 outline-1")}
      />
    </div>
  );
};

export default DecimalInput;
